<template>
    <div class="mb-4">
        <div ref="qrveyContainer2">
        </div>
    </div>
</template>

<script>

    import Mixin from '../reports/mixin';
    export default {
        mixins: [Mixin],
        name: 'qrvey-custom-report',
        props: [
            'reportId',
            'team',
            'user',
        ],

        created() {
        },
        data() {
            return {}
        },
        mounted() {
            setTimeout(() =>{
                this.loadQrveyPageWidget(this.team, this.reportId, this.$refs.qrveyContainer2, false, true, true, this.user.uuid)

            }, 1000)
        },
        methods: {
        }
    }
</script>
